
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import _ from 'lodash';

import Email from './summaries/Email.vue';
import Sms from './summaries/Sms.vue';
import Account from './summaries/Account.vue';
import Zone from './summaries/Zone.vue';
import Opportunity from './summaries/Opportunity.vue';
import InfoBox from './summaries/InfoBox.vue';
import EventExtension from './summaries/EventExtension.vue';
import ExtendTimeout from './summaries/ExtendTimeout.vue';
import If from './summaries/If.vue';
import List from './summaries/List.vue';
import End from './summaries/End.vue';
import Bo from './summaries/Bo.vue';
import Activity from './summaries/Activity.vue';
import Mailing from './summaries/Mailing.vue';
import MailingOpen from './summaries/MailingOpen.vue';
import MailingClick from './summaries/MailingClick.vue';
import Flow from './summaries/Flow.vue';
import TNodeSummary from './summaries/NodeSummary.vue';

import PlumbNodeMixin from './PlumbNodeMixin';

@Component({
  name: 'Plumb',
  components: {
    TNodeSummary,
    Activity,
    Opportunity,
    ExtendTimeout,
    Zone,
    EventExtension,
    InfoBox,
    Account,
    Sms,
    Email,
    If,
    List,
    End,
    Bo,
    Mailing,
    MailingOpen,
    MailingClick,
    Flow,
  },
})
export default class PlumbNodeSummary extends PlumbNodeMixin {}
